// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__7Ul0z","top":"Tooltip_top__fWlhB","bottom":"Tooltip_bottom__BgybL"};